import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DeletionService } from '../../../../../service/deletion.service';

@Component({
  selector: 'app-delete-company',
  standalone: false,
  templateUrl: './delete-company.component.html',
  styleUrl: './delete-company.component.scss'
})
export class DeleteCompanyComponent {
  membersDelete: boolean = false;
  private dialogRef = inject(MatDialogRef<DeleteCompanyComponent>);

  constructor(private deletionService: DeletionService) {}

  close() {
    this.dialogRef.close()
  }

  async deleteCompany() {
    console.log(this.membersDelete);
    let result = await this.deletionService.deleteCompany(this.membersDelete);
    this.close()
  }
}
